import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getSrcString } from '../helpers/getSrcStrings';

import styles from './HpRespPromoModulePromoItemOld.scss';

function HpRespPromoModulePromoItemOld({ promotion, className, onClick }) {
    const { mobileImageUrl, imageUrl, link } = promotion;

    const itemClassNames = classnames(styles.item, className);

    const shownImageUrl = imageUrl || mobileImageUrl;

    return (
        <div className={itemClassNames}>
            <a href={link} className={styles.link} onClick={onClick}>
                <img className={styles.image} src={getSrcString({ url: shownImageUrl })} />
            </a>
        </div>
    );
}

HpRespPromoModulePromoItemOld.propTypes = {
    promotion: PropTypes.shape({
        imageUrl: PropTypes.string,
        mobileImageUrl: PropTypes.string,
        link: PropTypes.string,
        imageHeight: PropTypes.string,
        alignment: PropTypes.string,
        isLinkable: PropTypes.bool,
    }).isRequired,
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

HpRespPromoModulePromoItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespPromoModulePromoItemOld };
